import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TmsWebBaseDragAndDropService } from './base';
import { HttpService } from './http.service';
import { DragAndDropDocument } from '../models';

@Injectable({
  providedIn: 'root',
})
export class DragAndDropService extends TmsWebBaseDragAndDropService {
  constructor(protected httpService: HttpService) {
    super('DragAndDrop', httpService);
  }

  listFiles(dragAndDropDocument: DragAndDropDocument): Observable<any> {
    return this.httpService.get(
      `${this.apiUrl}/ListFiles/${dragAndDropDocument.folderName}/${dragAndDropDocument.subFolderName}`,
    );
  }

  uploadFile(dragAndDropDocument: DragAndDropDocument, file: any): Observable<string> {
    return this.httpService
      .postForText(
        `${this.apiUrl}/UploadFile/${encodeURIComponent(dragAndDropDocument.folderName)}/${btoa(
          unescape(encodeURIComponent(dragAndDropDocument.subFolderName)),
        )}/${btoa(unescape(encodeURIComponent(dragAndDropDocument.fileName)))}`,
        file,
      )
      .pipe(map((fileUrl: string) => decodeURIComponent(fileUrl)));
  }

  uploadPDF(dragAndDropDocument: DragAndDropDocument, file: string): Observable<string> {
    return this.httpService
      .postForText(
        `${this.apiUrl}/UploadPDF/${encodeURIComponent(dragAndDropDocument.folderName)}/${btoa(
          unescape(encodeURIComponent(dragAndDropDocument.subFolderName)),
        )}/${btoa(unescape(encodeURIComponent(dragAndDropDocument.fileName)))}
        /${encodeURIComponent(dragAndDropDocument.container)}`,
        file,
      )
      .pipe(map((fileUrl: string) => decodeURIComponent(fileUrl)));
  }

  uploadImage(dragAndDropDocument: DragAndDropDocument, file: any): Observable<string> {
    return this.httpService
      .postForText(
        `${this.apiUrl}/UploadImage/${encodeURIComponent(dragAndDropDocument.folderName)}/${btoa(
          unescape(encodeURIComponent(dragAndDropDocument.subFolderName)),
        )}/${btoa(unescape(encodeURIComponent(dragAndDropDocument.fileName)))}`,
        file,
      )
      .pipe(map((fileUrl: string) => decodeURIComponent(fileUrl)));
  }

  removeFile(fullPathName: string): Observable<any> {
    return this.httpService.delete(`${this.apiUrl}/${btoa(unescape(encodeURIComponent(fullPathName)))}`);
  }

  openPreview(fullPath: string) {
    window.open(fullPath);
  }
}
